import { FeatureNameType } from 'common/open-features'

export const shouldRenderMenuItem = (
  featureFlags: Partial<Record<FeatureNameType, boolean>>,
  featureFlagKey?: string
): boolean => {
  return featureFlagKey ? !!featureFlags[featureFlagKey as FeatureNameType] : true
}

// 仮勘定連携 is hidden for NetSuite-enabled offices
const NETSUITE_HIDDEN_KEYS = new Set(['journal-entry-processing', 'setting.journal-entry-import'])

export const isHiddenForNetsuite = (isNetsuiteLinked: boolean | undefined, key: string): boolean =>
  !!isNetsuiteLinked && NETSUITE_HIDDEN_KEYS.has(key)
